import {
  deleteContractLocation,
  clearContractLocationAction,
} from 'actions/contracts/contractLocationActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const ContractLocationDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractLocationAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteContractLocation(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this contract location? This can not be
        undone.
      </div>
    </form>
  )
}

export default ContractLocationDelete
